// extracted by mini-css-extract-plugin
module.exports = {"navBar":"MainMenu_navBar__1RgFV","drawerLink":"MainMenu_drawerLink__1t4WY"};